import 'flowbite';

document.addEventListener( 'DOMContentLoaded', function() {
    console.log('Main script loaded 2');
  }
);
